import React from 'react'
import "./popup.css"
import win from "../../images/win.png"
import lose from "../../images/lose.png"
import error from "../../images/error.png"

const Popup = props => {

    return (
        <div className="popupComponent">

            {props.case === "4" &&
                <div className="popup winPopup">
                    <img src={win} />
                    Честитамо! <br className="mobileDisplay" /> Освојили сте награду - <br />
                    {props.prizeCode === "1" && <span>СЕТ ЗА РОШТИЉ.</span>}
                    {props.prizeCode === "2" && <span>КУХИЊСКИ ФРИЖИДЕР.</span>}
                    {props.prizeCode === "3" && <span>ВАУЧЕР ОД 2000 ЕВРА ЗА ОПРЕМАЊЕ КУХИЊЕ.</span>}
                    {props.prizeCode === "4" && <span>АУТОМОБИЛ ШКОДА ОКТАВИЈА.</span>}


                    <br className="mobileDisplay" />
                    Бићете контактирани у нареднa 3 радна дана ради
                    узимања података. <br className="mobileDisplay" />  <br className="mobileDisplay" />
                    Сачувајте свој добитни затварач.
                </div>}

            {props.case === "1" &&
                <div className="popup losePopup">
                    <img src={lose} />
                    Поштовани, нисте освојили ниједну награду.
                    <br className="mobileDisplay" />
                    <br className="mobileDisplay" />
                    {" "}Желимо Вам више среће следећи пут!
                </div>}

            {props.case === "2" &&
                <div className="popup errorPopup">
                    <img src={error} />
                    Поштовани, код који сте унели је неисправан.
                    <br className="mobileDisplay" />
                    <br className="mobileDisplay" />
                    {" "}Молимо Вас, контактирајте наш контакт центар
                    или покушајте поново.
                </div>}

            {props.case === "3" &&
                <div className="popup errorPopup">
                    <img src={error} />
                    Поштовани, код који сте унели је већ искоришћен.
                    <br className="mobileDisplay" />
                    <br className="mobileDisplay" />
                    {" "}У току трајања наградне игре, један исти код
                    се не може користити више пута.

                </div>}

            {props.case === "5" &&
                <div className="popup errorPopup">
                    <img src={error} />
                    Поштовани, игра још није почела.
                </div>}

            {props.case === "6" &&
                <div className="popup errorPopup">
                    <img src={error} />
                    Поштовани, игра је завршена.

                </div>}

            {props.case === "91" &&
                <div className="popup errorPopup">
                    <img src={error} />
                    Поштовани, <br />
                    Због уноса великог броја неисправних кодова, привремено вам је онемогућено да учествујете у Наградној игри Зајечарско части. <br /> <br />
                    Даље слање неисправних кодова довешће до дисквалификације.
                    За више информација контактирајте наш контакт центар.
                </div>}

            {props.case === "94" &&
                <div className="popup errorPopup">
                    <img src={error} />
                    Поштовани, <br />
                    Због поновљеног уноса великог броја неисправних кодова, трајно сте дисквалификовани из наградне игре Зајечарско части. <br/> <br/>
                    За више информација контактирајте наш контакт центар.
                </div>}




        </div >
    )
}

export default Popup
